import * as React from "react";
import ReactTable from "react-table";
import { Glyphicon, ButtonToolbar, OverlayTrigger, Tooltip, Alert, Button } from "react-bootstrap";
import { GlosaEmpleador, FiltroGlosasEmpleador, RespuestaGestionGlosas } from "../modelo/GlosaEmpleador";
import { REQUEST } from "../../../../config/ajax-wrapper";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DotLoader } from "react-spinners";
import { EstadoGlosa } from "../modelo/EstadosGlosa";
import { ModalDetallesGlosa } from "./ModalDetallesGlosa";
import { ModalRespuestaGestionGlosas } from "./ModalRespuestaGestionGlosas";
import { generarXLSRespuestaGestionGlosas } from "../modelo/RespuestaGestionGlosasXLS";
import { TransaccionSat } from "../../../general/modelo/TransaccionSat";
import Toggle from 'material-ui/Toggle';
import { ColumnaProps, OrdenamientoProps } from "../../../general/modelo/TablaColumnas";
import { TipoOrdenamiento, ParamOrdenamientoGlosas, OrdenamientoGlosas } from "../modelo/OrdenamientoGlosas";
import RedireccionConsulta from "../../config_general/componentes/RedireccionConsulta";

export default class TablaGlosas extends React.Component<TablaGlosasProps, any> {

    columns = [{
        id: "consecutivo",
        Header: "Consecutivo",
        accessor: "consecutivo",
        Cell: props => (this.renderAccionConsecutivo(props)),
        width: 70,
        sortable: false
    }, {
        id: "fechaOperacion",
        Header: "Fecha Operación",
        accessor: "fechaOperacion",
        width: 118,
        sortable: true
    }, {
        id: "dniEmpleador",
        Header: "Identificación",
        accessor: "dniEmpleador",
        Cell: props => (this.renderAccionDni(props)),
        width: !this.props.esAfiliacionTraslado ? 98 : 125,
        sortable: true
    }, {
        id: "nombreEmpleador",
        Header: "Nombre Empleador",
        accessor: "nombreEmpleador",
        Cell: props => (this.renderNombreEmpleador(props)),
        show: !this.props.esAfiliacionTraslado,
        sortable: true
    }, {
        id: "uen",
        Header: "UEN",
        accessor: "uen",
        width: !this.props.esAfiliacionTraslado ? 42 : undefined,
        show: !this.props.esAfiliacionTraslado,
        sortable: true
    }, {
        id: "codigoServicio",
        Header: "Tipo Transacción",
        accessor: "codigoServicio",
        Cell: props => (this.renderTipoTransaccion(props)),
        width: this.definirTamanoTipoTransacción(),
        sortable: true
    }, {
        id: "estadoGlosa",
        Header: "Estado",
        accessor: "estado",
        Cell: props => (this.renderEstado(props)),
        width: !this.props.esAfiliacionTraslado ? 100 : undefined,
        sortable: true
    }, {
        id: "estadoPoliza",
        Header: "Estado Póliza",
        accessor: "estadoPoliza",
        Cell: props => (this.renderEstadoPoliza(props)),
        width: 80,
        sortable: true
    }, {
        id: "usuario",
        Header: "Usuario Proceso",
        accessor: "usuario",
        width: 120,
        show: this.props.esAfiliacionTraslado,
        sortable: false
    }, {
        id: "codigoGlosa",
        Header: "Glosa",
        accessor: "codigoGlosa",
        width: 50,
        sortable: true
    }, {
        id: "periodo",
        Header: "Periodo",
        accessor: "detalleGlosa",
        Cell: props => (this.renderPeriodoMora(props)),
        width: 60,
        show: this.props.esReporteMora,
        sortable: false
    }, {
        id: "tipoReporte",
        Header: "Reporte",
        accessor: "detalleGlosa",
        Cell: props => (this.renderTipoReporte(props)),
        width: 50,
        show: this.props.esReporteMora,
        sortable: false
    }, {
        id: "descripcionGlosa",
        Header: "Detalle Glosa",
        accessor: "descripcionGlosa",
        Cell: props => (this.renderDetalleGlosa(props)),
        width: 85,
        sortable: false
    }, {
        id: "verDetalle",
        Header: "Ver Detalle",
        accessor: "dniEmpleador",
        Cell: props => (this.renderModalDetallesGlosa(props)),
        width: 76,
        sortable: false
    }, {
        id: "consecutivo",
        Header: () => (this.renderHeaderSeleccionMasiva()),
        accessor: "consecutivo",
        Cell: props => (this.renderEstadoGlosa(props)),
        width: 70,
        sortable: false
    }];

    constructor(props: any) {
        super(props);
        this.state = {
            listaSeleccionGlosas: [],
            showAlert: true,
            showModalRespuestaGestionGlosas: false
        };
    }

    handleDismissAlert() {
        this.setState({ showAlert: false });
    }

    renderNombreEmpleador = (props: any) => {
        if (props.value) {
            if (props.value.length > 20) {
                const tooltip = (
                    <Tooltip id="tooltip" className="tooltip-pos" arrowOffsetTop={20}>{props.value}</Tooltip>
                );
                return (
                    <OverlayTrigger placement="top" overlay={tooltip}>
                        <span>{props.value}</span>
                    </OverlayTrigger>
                );
            }
        }
        return (props.value);
    }

    renderTipoTransaccion = (props: any) => {
        return (
            <div>
                {this.props.obtenerNombreTipoTransaccion(props.value)}
            </div>
        );
    }

    renderEstado = (props: any) => {
        if (props.value === EstadoGlosa.invalido) {
            if (props.original.observacionGestion) {
                const tooltip = (
                    <Tooltip id="tooltip">
                        {props.original.observacionGestion}
                    </Tooltip>
                );
                return (
                    <OverlayTrigger placement="top" overlay={tooltip}>
                        <div className={"text-center"}>
                            {props.value}
                        </div>
                    </OverlayTrigger>
                );
            }
        }
        return props.value;
    }

    renderEstadoPoliza = (props: any) => {
        return props.value.replace(/\_/gi, ' ');
    }

    renderDetalleGlosa = (props: any) => {
        const tooltip = (
            <Tooltip id="tooltip">
                {this.descripcionDetalleGlosa(props)}
            </Tooltip>
        );
        return (
            <div className={"text-center"}>
                <ButtonToolbar>
                    <OverlayTrigger placement="top" overlay={tooltip}>
                        <a className="btns btns-primary">
                            <Glyphicon glyph={"info-sign"} />
                        </a>
                    </OverlayTrigger>
                </ButtonToolbar>
            </div>
        );
    }

    renderPeriodoMora = (props: any) => {
        return JSON.parse(props.original.detalleGlosa).Periodo;
    }

    renderTipoReporte = (props: any) => {
        return JSON.parse(props.original.detalleGlosa).TipoReporte;
    }

    renderModalDetallesGlosa = (props: any) => {
        return (
            <ModalDetallesGlosa
                dniEmpleador={props.original.dniEmpleador}
                codigoServicio={props.original.codigoServicio}
                consecutivo={props.original.consecutivo}
                nombreEmpleador={props.original.nombreEmpleador}
                npoliza={props.original.npoliza}
                usuario={props.original.usuario}
                emailUsuario={props.original.emailUsuario}
                detalleGlosa={props.original.detalleGlosa}
                nombreTransaccion={this.props.obtenerNombreTipoTransaccion(props.original.codigoServicio)}
            />
        );
    };

    renderEstadoGlosa = (props: any) => {
        switch (props.original.estado) {
            case EstadoGlosa.pendiente: case EstadoGlosa.gestionar: case EstadoGlosa.invalido:
                return (
                    this.renderCheckBox(props)
                );
            case EstadoGlosa.enproceso:
                return (
                    this.renderEstadoGlosaIcono("transfer")
                );
            case EstadoGlosa.solucionado: case EstadoGlosa.anulado:
                return (
                    this.renderEstadoGlosaIcono("ok")
                );
            default:
                return (
                    this.renderEstadoGlosaIcono("ban-circle")
                );
        }
    };

    renderEstadoGlosaIcono(icono: string) {
        return (
            <span className="icons-table">
                <Glyphicon glyph={icono} />
            </span>
        );
    }

    renderCheckBox = (props: any) => {
        if (props.original.estado === EstadoGlosa.pendiente || props.original.estado === EstadoGlosa.gestionar || props.original.estado === EstadoGlosa.invalido) {
            const enabledMasivos = this.props.estadoMasivoActivo();
            return (
                <div className={"text-center"}>
                    <input type="checkbox"
                        disabled={enabledMasivos}
                        className={"checkbox-center"}
                        checked={enabledMasivos ? true : this.glosaEmpleadorSeleccionada(props.original)}
                        onChange={() => this.seleccionarFila(props.original)} />
                </div>
            );
        }
    };

    renderCheckBoxSolucionado = (props: any) => {
        if (props.original.estado === EstadoGlosa.solucionado){
            const enabledMasivos = this.props.estadoMasivoActivo();
            return (
                <div className={"text-center"}>
                    <input type="checkbox"
                        disabled={enabledMasivos}
                        className={"checkbox-center"}
                        checked={enabledMasivos ? true : this.glosaEmpleadorSeleccionada(props.original)}
                        onChange={() => this.seleccionarFila(props.original)} />
                </div>
            );
        }
    }

    seleccionarFila(glosaEmpleador: GlosaEmpleador) {
        const actualizarLista = this.props.retornarListaGestionGlosas();
        if (!this.glosaEmpleadorSeleccionada(glosaEmpleador)) {
            actualizarLista.push(glosaEmpleador);
        } else {
            this.props.retornarListaGestionGlosas().forEach((element, index) => {
                if (element.dniEmpleador === glosaEmpleador.dniEmpleador && element.consecutivo === glosaEmpleador.consecutivo) {
                    actualizarLista.splice(index, 1);
                    return;
                }
            });
        }
        this.props.seleccionGlosasGestion(actualizarLista);
    }

    glosaEmpleadorSeleccionada(glosaEmpleador: GlosaEmpleador) {
        return this.props.retornarListaGestionGlosas().some(
            (element: GlosaEmpleador) =>
                element.dniEmpleador === glosaEmpleador.dniEmpleador && element.consecutivo === glosaEmpleador.consecutivo
        );
    }

    renderHeaderSeleccionMasiva = () => {
        const tooltipHeader = (
            <Tooltip id="tooltip">
                <span className="tooltip-font">Clic para seleccionar todas las glosas de la página actual</span>
            </Tooltip>
        );
        return (
            <div style={{ marginTop: '-3px' }} onClick={() => this.masivoSeleccionGestionGlosas()}>
                <span>Seleccionar</span>
                <OverlayTrigger placement="right" overlay={tooltipHeader}>
                    <Glyphicon className={"info-sign icon-title"} glyph={"info-sign"} />
                </OverlayTrigger>
            </div>
        );
    };

    masivoSeleccionGestionGlosas() {
        const { glosasEmpleador } = this.props;
        const listaSeleccion = this.props.retornarListaGestionGlosas();
        if (this.totalGlosasDisponiblesPorGestionar() === listaSeleccion.length) {
            this.props.seleccionGlosasGestion([]);
        } else {
            listaSeleccion.splice(0, listaSeleccion.length);
            glosasEmpleador.forEach((glosaEmpleador: GlosaEmpleador) => {
                if (this.validarGlosaGestionable(glosaEmpleador)) {
                    listaSeleccion.push(glosaEmpleador);
                }
            });
            this.props.seleccionGlosasGestion(listaSeleccion);
        }
    }

    totalGlosasDisponiblesPorGestionar() {
        const { glosasEmpleador } = this.props;
        return glosasEmpleador.filter(glosa => this.validarGlosaGestionable(glosa)).length;
    }

    validarGlosaGestionable(glosaEmpleador: GlosaEmpleador) {
        const { esAfiliacionTraslado } = this.props;
        return ((glosaEmpleador.estado === EstadoGlosa.pendiente || glosaEmpleador.estado === EstadoGlosa.gestionar || glosaEmpleador.estado === EstadoGlosa.invalido)
            && !(esAfiliacionTraslado && glosaEmpleador.glosaBloqueante === 'S'));
    }

    totalGlosasNoGestionadas() {
        const { listaRespuestaGestionGlosas } = this.props;
        return listaRespuestaGestionGlosas.filter(glosa => !glosa.exitoGestion).length;
    }

    render() {
        const { glosasEmpleador, estado, paginas, tamanoPagina, paginaActual, errorMasivoGlosas } = this.props;
        switch (estado) {
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.FORBIDDEN:
                return <Mensaje type={"danger"} mensaje={"No estas autorizado para gestionar glosas"} />;
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"}
                            mensaje={this.props.mensajeAction ? this.props.mensajeAction : "Las glosas seleccionadas se han enviado a gestionar exitosamente al SAT"} />
                        {this.renderGlosasEmpleador(glosasEmpleador, paginas, tamanoPagina, paginaActual)}
                    </span>
                );
            case REQUEST.ERROR:
                if (errorMasivoGlosas) {
                    return (
                        <div>
                            <span>
                                {this.state.showAlert && this.renderAlertaGlosasMasivo()}
                            </span>
                            {this.renderGlosasEmpleador(glosasEmpleador, paginas, tamanoPagina, paginaActual)}
                        </div>
                    );
                } else {
                    return (
                        <div>
                            {this.state.showModalRespuestaGestionGlosas && this.renderModalRespuestaGestionGlosas()}
                            <span>
                                {this.state.showAlert && this.renderAlertaGlosas()}
                                {this.renderGlosasEmpleador(glosasEmpleador, paginas, tamanoPagina, paginaActual)}
                            </span>
                        </div>
                    );
                }
            default:
                return this.renderGlosasEmpleador(glosasEmpleador, paginas, tamanoPagina, paginaActual);
        }
    }

    renderAlertaGlosas() {
        return (
            <Alert bsStyle="warning" onDismiss={() => this.handleDismissAlert()}>
                <h4>Se ha presentado un error!</h4>
                {
                    this.totalGlosasNoGestionadas() === 1 &&
                    <p style={{ fontSize: "15px", color: "#a94442" }}>
                        El sistema no pudo gestionar la glosa seleccionada, se presentó un error técnico o de usuario.
                        Para ver más información del error que se presentó, tienes la opción para visualizar en línea o descargar el informe.
                    </p>
                }
                {
                    this.totalGlosasNoGestionadas() > 1 &&
                    <p style={{ fontSize: "15px", color: "#a94442" }}>
                        El sistema no pudo gestionar {this.totalGlosasNoGestionadas()} de las glosas seleccionadas, se presentó un error ténico o de usuario.
                        Para ver más información del error que se presentó, tienes la opción para visualizar en línea o descargar el informe.
                    </p>
                }
                <p className="btns-alert-right">
                    <Button bsStyle="warning" onClick={() => this.descargarXLSRespuestaGestionGlosas()}>Descargar</Button>
                    <Button bsStyle="warning" onClick={() => this.setState({ showModalRespuestaGestionGlosas: true })}>Visualizar</Button>
                </p>
            </Alert>
        );
    }

    renderAlertaGlosasMasivo() {
        return (
            <Alert bsStyle="warning" onDismiss={() => this.handleDismissAlert()}>
                <h4>Se ha presentado un error!</h4>
                <p style={{ fontSize: "15px", color: "#a94442" }}>
                    El sistema no pudo reprocesar masivamente todas las glosas encontradas. <b>Error:</b> {this.props.mensajeAction}.
                </p>
            </Alert>
        );
    }

    renderModalRespuestaGestionGlosas() {
        return (
            <ModalRespuestaGestionGlosas
                listaRespuestaGestionGlosas={this.props.listaRespuestaGestionGlosas}
                dniUsuarioGestionLogin={this.props.dniUsuarioGestionLogin}
                esAfiliacionTraslado={this.props.esAfiliacionTraslado}
                cerrarModalRespuestaGestionGlosas={this.handleCloseModalRespuestaGestionGlosas}
                obtenerNombreTipoTransaccion={this.props.obtenerNombreTipoTransaccion}
            />
        );
    }

    handleCloseModalRespuestaGestionGlosas = () => {
        this.setState({ showModalRespuestaGestionGlosas: false });
    };

    handleToggleMasivos = (event: object, inputToggle: boolean) => {
        if (inputToggle) {
            this.props.configActivarMasivoGlosas(true);
        } else {
            this.props.configActivarMasivoGlosas(false);
        }
    }

    renderGlosasEmpleador(glosasEmpleador: Array<GlosaEmpleador>, paginas: number, tamanoPagina: number, paginaActual: number) {

        let numRegistros = 0;

        if (glosasEmpleador.length < tamanoPagina) {
            numRegistros = glosasEmpleador.length;
        } else {
            numRegistros = tamanoPagina;
        }

        const tooltipToggle = (
            <Tooltip id="tooltip">
                <span className="tooltip-font">{this.props.estadoMasivoActivo() ? 'Desactivar' : 'Activar'} la gestión masiva de glosas en SAT</span>
            </Tooltip>
        );

        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{glosasEmpleador.length}</span> Inconsistencias encontradas
                    </h2>
                    <div className="icon-head-toggle">
                        <OverlayTrigger placement="top" overlay={tooltipToggle}>
                            <Glyphicon className={"cog"} glyph={"cog"} style={{ marginLeft: "-120px" }} />
                        </OverlayTrigger>
                    </div>
                    <div className="position-head-toggle">
                        <Toggle
                            style={{ marginBottom: 16 }}
                            thumbSwitchedStyle={{ backgroundColor: '#00aec7' }}
                            trackSwitchedStyle={{ backgroundColor: '#3895a3' }}
                            onToggle={(event: object, inputToggle: boolean) => this.handleToggleMasivos(event, inputToggle)}
                            disabled={!this.props.validarEstadoGestionGlosasActivo(this.props.filtroGlosasEmpleador.estado)}
                            toggled={this.props.estadoMasivoActivo()}
                        />
                    </div>
                </div>
                <ReactTable data={glosasEmpleador}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                    onSortedChange={(newSorted, column, shiftKey) => {
                        this.ordernamientoLista(newSorted, column, shiftKey);
                    }}
                />
            </div>
        );
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 30, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroGlosasEmpleador: FiltroGlosasEmpleador = {
            dni: this.props.filtroGlosasEmpleador.dni,
            tipoTransaccion: this.props.filtroGlosasEmpleador.tipoTransaccion,
            estado: this.props.filtroGlosasEmpleador.estado,
            uen: this.props.filtroGlosasEmpleador.uen,
            tipoGestion: this.props.filtroGlosasEmpleador.tipoGestion,
            usuario: this.props.filtroGlosasEmpleador.usuario,
            fuenteIngreso: this.props.filtroGlosasEmpleador.fuenteIngreso,
            estadoPoliza: this.props.filtroGlosasEmpleador.estadoPoliza,
            codigoGlosa: this.props.filtroGlosasEmpleador.codigoGlosa,
            fechaInicial: this.props.filtroGlosasEmpleador.fechaInicial,
            fechaFinal: this.props.filtroGlosasEmpleador.fechaFinal,
            periodoInicio: this.props.filtroGlosasEmpleador.periodoInicio,
            periodoFin: this.props.filtroGlosasEmpleador.periodoFin,
            registrosPorPagina: pageSize ? pageSize : tamanoPagina,
            pagina: pageIndex,
        };
        this.props.consultaPaginada(filtroGlosasEmpleador, this.props.ordenamientoGlosas);
    }

    ordernamientoLista(ordenamientoProps: Array<OrdenamientoProps>, columnaProps: ColumnaProps, shiftKey: boolean) {
        const ordenamiento = ordenamientoProps[0];

        const tipoOrdenamiento: TipoOrdenamiento = this.props.ordenamientoGlosas ?
            (this.props.ordenamientoGlosas.tipoOrdenamiento === TipoOrdenamiento.DESCENDENTE ? TipoOrdenamiento.ASCENDENTE : TipoOrdenamiento.DESCENDENTE) : TipoOrdenamiento.DESCENDENTE;

        const parametroOrdenamiento = () => {
            if (ordenamiento.id === 'fechaOperacion')
                return ParamOrdenamientoGlosas.FECHA_OPERACION;
            if (ordenamiento.id === 'dniEmpleador')
                return ParamOrdenamientoGlosas.DNI_EMPLEADOR;
            if (ordenamiento.id === 'nombreEmpleador')
                return ParamOrdenamientoGlosas.NOMBRE_EMPLEADOR;
            if (ordenamiento.id === 'uen')
                return ParamOrdenamientoGlosas.UEN;
            if (ordenamiento.id === 'codigoServicio')
                return ParamOrdenamientoGlosas.CODIGO_SERVICIO;
            if (ordenamiento.id === 'codigoGlosa')
                return ParamOrdenamientoGlosas.CODIGO_GLOSA;
            if (ordenamiento.id === 'estadoGlosa')
                return ParamOrdenamientoGlosas.ESTADO_GLOSA;
            if (ordenamiento.id === 'estadoPoliza')
                return ParamOrdenamientoGlosas.ESTADO_POLIZA;
            return undefined;
        };

        const ordenamientoGlosas: OrdenamientoGlosas = {
            paramOrdenamiento: parametroOrdenamiento(),
            tipoOrdenamiento: tipoOrdenamiento
        };

        const filtroGlosasEmpleador: FiltroGlosasEmpleador = {
            dni: this.props.filtroGlosasEmpleador.dni,
            tipoTransaccion: this.props.filtroGlosasEmpleador.tipoTransaccion,
            estado: this.props.filtroGlosasEmpleador.estado,
            uen: this.props.filtroGlosasEmpleador.uen,
            tipoGestion: this.props.filtroGlosasEmpleador.tipoGestion,
            usuario: this.props.filtroGlosasEmpleador.usuario,
            fuenteIngreso: this.props.filtroGlosasEmpleador.fuenteIngreso,
            estadoPoliza: this.props.filtroGlosasEmpleador.estadoPoliza,
            codigoGlosa: this.props.filtroGlosasEmpleador.codigoGlosa,
            fechaInicial: this.props.filtroGlosasEmpleador.fechaInicial,
            fechaFinal: this.props.filtroGlosasEmpleador.fechaFinal,
            periodoInicio: this.props.filtroGlosasEmpleador.periodoInicio,
            periodoFin: this.props.filtroGlosasEmpleador.periodoFin,
            registrosPorPagina: this.props.tamanoPagina,
            pagina: this.props.paginaActual,
        };

        this.props.consultaPaginada(filtroGlosasEmpleador, ordenamientoGlosas);
    }

    descripcionDetalleGlosa = (props: any) => {
        if (!props.value) {
            switch (props.original.estado) {
                case EstadoGlosa.enproceso: return "Esta glosa ya fué gestionada y se está procesando en el SAT";
                case EstadoGlosa.solucionado: return "Esta novedad se ha enviado exitosamente al SAT";
                default: return "El detalle de la glosa o motivo de rechazo de esta glosa es desconocida o la glosa no esta clasificada";
            }
        }
        return props.value;
    };

    descargarXLSRespuestaGestionGlosas() {
        if (this.props.listaRespuestaGestionGlosas.length > 0 && this.props.transaccionesSat.length > 0) {
            generarXLSRespuestaGestionGlosas(this.props.listaRespuestaGestionGlosas, this.props.transaccionesSat, this.props.esAfiliacionTraslado);
        }
    }

    definirTamanoTipoTransacción() {
        if (this.props.esReporteMora) return 110;
        return !this.props.esAfiliacionTraslado ? 214 : undefined;
    }

    renderAccionConsecutivo = (props: any) => {
        const codigoServicio = props.original.codigoServicio;
        const consecutivo = props.original.consecutivo;

        if (codigoServicio && consecutivo) {
            return (
                <RedireccionConsulta
                    textoAyuda="Ver Respuesta Consecutivo"
                    url={`consultarHistoricoRespuestaSAT?codigoServicio=${codigoServicio}&consecutivo=${consecutivo}`}
                    textoLink={consecutivo}
                />
            );
        } else {
            return props.value;
        }
    };

    renderAccionDni = (props: any) => {
        const codigoServicio = props.original.codigoServicio;
        const dni = props.original.dniEmpleador;

        if (codigoServicio && dni) {
            return (
                <RedireccionConsulta
                    textoAyuda="Ver Respuesta Dni"
                    url={`consultarHistoricoRespuestaSAT?codigoServicio=${codigoServicio}&dni=${dni}`}
                    textoLink={dni}
                />
            );
        } else {
            return props.value;
        }
    };
}

interface TablaGlosasProps {
    glosasEmpleador?: Array<GlosaEmpleador>,
    estado?: REQUEST,
    filtroGlosasEmpleador?: FiltroGlosasEmpleador
    paginas?: number,
    tamanoPagina?: number,
    paginaActual?: number,
    esAfiliacionTraslado?: boolean,
    esReporteMora?: boolean,
    listaRespuestaGestionGlosas?: Array<RespuestaGestionGlosas>,
    transaccionesSat?: Array<TransaccionSat>,
    dniUsuarioGestionLogin?: string,
    errorMasivoGlosas?: boolean,
    mensajeAction?: string,
    ordenamientoGlosas?: OrdenamientoGlosas,
    seleccionGlosasGestion?: (listaSeleccionGlosas: Array<GlosaEmpleador>) => void,
    retornarListaGestionGlosas?: () => Array<GlosaEmpleador>,
    consultaPaginada?: (filtroGlosasEmpleador: FiltroGlosasEmpleador, ordenamiento: OrdenamientoGlosas) => void,
    obtenerNombreTipoTransaccion?: (codigo: number) => string,
    configActivarMasivoGlosas?: (activo: boolean) => void,
    estadoMasivoActivo?: () => boolean,
    validarEstadoGestionGlosasActivo?: (estado: string) => boolean,
    estadoSolucionado: () => boolean
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/componentes/TablaGlosas.tsx